// Botón flotante de música on/off + popup "Escuchar en Spotify" al pasar el mouse
// (mismo comportamiento que en TERA).
import React, { useEffect, useRef, useState } from "react";
import { AUDIO_SRC, AUDIO_START_AT_SECONDS, SPOTIFY_URL } from "./config";
import { SpotifyIcon } from "./Chrome26";

export default function MusicPlayer26() {
  const audioRef = useRef(null);
  const hideTimerRef = useRef(null);
  const startedRef = useRef(false);
  const [playing, setPlaying] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    audio.addEventListener("play", onPlay);
    audio.addEventListener("pause", onPause);

    // Saltar la intro cuando ya hay metadatos (en mobile, antes puede
    // hacer fallar el play() en silencio).
    const seekToStart = () => {
      if (startedRef.current) return;
      audio.currentTime = AUDIO_START_AT_SECONDS;
      startedRef.current = true;
    };
    if (audio.readyState >= 1) seekToStart();
    else audio.addEventListener("loadedmetadata", seekToStart, { once: true });

    // Intento de autoplay: casi siempre lo bloquea el navegador; en ese caso
    // queda pausado hasta que el usuario toque el botón.
    audio.play().catch(() => {});

    return () => {
      audio.removeEventListener("play", onPlay);
      audio.removeEventListener("pause", onPause);
      audio.removeEventListener("loadedmetadata", seekToStart);
    };
  }, []);

  useEffect(() => {
    const onVisibility = () => {
      const audio = audioRef.current;
      if (audio && document.visibilityState === "hidden" && !audio.paused) audio.pause();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) audio.play().catch(() => {});
    else audio.pause();
  };

  const openPopup = () => {
    clearTimeout(hideTimerRef.current);
    setShowPopup(true);
  };
  const scheduleClose = () => {
    clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => setShowPopup(false), 3500);
  };

  useEffect(() => {
    if (!showPopup) return;
    const closeNow = () => {
      clearTimeout(hideTimerRef.current);
      setShowPopup(false);
    };
    window.addEventListener("scroll", closeNow, { passive: true });
    return () => window.removeEventListener("scroll", closeNow);
  }, [showPopup]);

  return (
    <>
      <audio ref={audioRef} src={AUDIO_SRC} loop preload="metadata" />
      <div className="q26-music" onMouseEnter={openPopup} onMouseLeave={scheduleClose}>
        {showPopup && (
          <a className="q26-spotify-pop" href={SPOTIFY_URL} target="_blank" rel="noopener noreferrer">
            <SpotifyIcon />
            Escuchar en Spotify ↗
          </a>
        )}
        <button
          className={"q26-music-btn" + (playing ? " is-playing" : "")}
          onClick={() => {
            toggle();
            openPopup();
            scheduleClose();
          }}
          aria-label={playing ? "Silenciar música" : "Reproducir música"}
          title={playing ? "Silenciar música" : "Reproducir música"}
        >
          <svg viewBox="0 0 24 24">
            {playing ? (
              <path
                d="M4 9h4l5-4v14l-5-4H4V9zm12.5-3.5a7 7 0 0 1 0 13M15.5 8.5a3.5 3.5 0 0 1 0 7"
                fill="none"
                stroke="#201f1f"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            ) : (
              <path
                d="M4 9h4l5-4v14l-5-4H4V9zM17 9l5 6M22 9l-5 6"
                fill="none"
                stroke="#201f1f"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            )}
          </svg>
        </button>
      </div>
    </>
  );
}
